import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { FetchDataService } from 'src/app/services/fetch-data/fetch-data.service';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [TranslateModule, AccordionModule, CommonModule],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css'],
})
export class FAQComponent {
   data: any[] = [];
    constructor(
      private content: FetchDataService,
      private translate: TranslateService
    ) {}
    ngOnInit(): void {
      this.loadContent(this.translate.currentLang);
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.loadContent(event.lang);
      });
    }
    loadContent(lang: string): void {
      this.content.getContentData(lang, 'faq').subscribe({
        next: (data) => {
          this.data = data;
        },
        error: (error) => {
          console.log(error);
        },
      });
    }

}
